<div class="row">
  <div class="col-md-12">
      <yt-useripadress-inline-update 
      #baseInlineUpdate
      (ItemSaved)="Refresh()">
    </yt-useripadress-inline-update>
  </div>
</div>
<div class="row">
  <div class="col-md-12">
    <yt-fw-default-detail-list-inline 
    #baseDetailList
    [Model]="modelData.MainList.DetailList[1]" 
    [ParentPropertyName]="_parentPropertyName"
    [ParentPropertyValue]="_parentPropertyValue" 
    [Disabled]="!_parentPropertyValue || _parentPropertyValue <= 0"
    (Items)="setItems($event)">
    </yt-fw-default-detail-list-inline>
  </div>
</div>
